import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ModalLoad.css';
import Modal from '../modal/Modal';
import i18n from 'i18n-react';

const defaultProps = {
  buttonModal: 'OK',
  showModal: false,
};

const propTypes = {
  id: PropTypes.string.isRequired,  
  showModal: PropTypes.bool.isRequired,
  buttonModal: PropTypes.string,
  header: PropTypes.string
};

class ModalLoad extends Component {
  render() {
    let width='220px';
    return (    
      <Modal hideCloseButton={true} width={width} id={`modal-${this.props.id}`} visible={this.props.showModal} onHide={()=>{}}>     
       <Row>
          <div className="ModalLoad__icon">
					 <i className="icon-spinner" />
				  </div>
				  <div className="ModalLoad__message text-warm-grey">					
          {i18n.translate('loading')}
				  </div>
        </Row>        
      </Modal>      
    );
  }
}

ModalLoad.defaultProps = defaultProps;
ModalLoad.propTypes = propTypes;

export default ModalLoad;


// WEBPACK FOOTER //
// ./src/components/modalLoad/ModalLoad.jsx